'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _selectors = require('./selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getUserTooltip = function getUserTooltip(level, user) {
  if (level.id === user) {
    return _react2.default.createElement(
      'div',
      { className: 'c-tooltip drop up' },
      'You'
    );
  }

  return null;
};

function RequiredEducation(_ref) {
  var educationLevels = _ref.educationLevels,
      job = _ref.job,
      user = _ref.user;

  var seen = false;

  var blankLevel = require('shared/images/level-blank.png');
  return _react2.default.createElement(
    'div',
    {
      className: 'levels'
    },
    educationLevels.map(function (level) {
      var className = [
      // This is a hack, because the job
      // education ID coming back
      // is in the form 3605
      // and the level ID comes back
      // as 1, 2, etc.
      !seen ? 'completed' : null, 'level'].join(' ');

      if (job.title === level.title) {
        seen = true;
      }

      return _react2.default.createElement(
        'div',
        {
          key: level.id,
          className: 'education-level-container'
        },
        _react2.default.createElement('img', {
          className: className,
          src: blankLevel,
          alt: level.label,
          title: level.label
        }),
        getUserTooltip(level, user)
      );
    })
  );
}

exports.default = (0, _reactRedux.connect)(_selectors.mapStateToProps)(RequiredEducation);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/RequiredEducation/RequiredEducation.jsx
// module id = 1117
// module chunks = 0